/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OpportunityStage {
  'Product Qualified' = 0,
  'Proposal Generated' = 1,
  'Appointment Confirmed' = 2,
  'Follow Up' = 3,
  'Proposal Accepted' = 4,
  'Closed Won' = 5,
  'Closed Lost' = 6,
}
